import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { NavigationService } from '../../shared/services/navigation.service';

@Injectable()
export class ManageSubcontractorsGuard implements CanActivate {

  constructor(private authService: AuthenticationService, private navigation: NavigationService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.navigation.redirectToHomeIfNotAllowed(() => this.authService.canManageSubcontractors());
  }
}
